<template>
    <section class="hero" :style="computedHeroStyle">
        <div class="hero-body">
            <div class="container has-text-centered">
                <h1 v-if="banner.title" class="cp-title-3 mb-4" :style="computedFontStyle">
                    {{ banner.title }}
                </h1>
                <a class="button is-medium is-size-5" 
                    :href="frontendUrl" 
                    :style="computedButtonStyle"
                >Quero me cadastrar</a>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'RegisterBanner',
    computed: {
        ...mapGetters({
            background_color: 'company/background_color',
            primary_color: 'company/primary_color',
            font_color: 'company/font_color',
            banner: 'company/banner',
            frontendUrl: 'company/frontend_domain',
        }),

        computedHeroStyle() {
            return {
                'background-color': this.primary_color
            }
        },

        computedFontStyle() {
            return {
                'color': this.font_color || 'red'
            }
        },

        computedButtonStyle() {
            return {
                'border-color': this.font_color,
                'background-color': this.primary_color,
                'color': this.font_color,
            }
        },
    },
}
</script>